module.exports = __webpack_public_path__ + "img/00303.MTS_snapshot_00.08.303 (1).23d2e316.jpg";